import React, { useEffect, useState } from 'react'
import { usePermissions } from '../../../../hooks/usePermissions';
import { Menuitem } from '../../../../interfaces/Security/menu';
import useSnackBar from '../../../../components/Commons/SnackBar/useSnackBar';
import GenericPromises from '../../../../api/GenericPromises';
import { Section } from '../../../../interfaces/Stocks/Warehouses/sections';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Spinner } from '../../../../components/Commons/Spinner/Spinner';
import { GenericDialog } from '../../../../components/Dialogs/Dialog';
import { Header } from '../../../../components/Header';
import { ButtonStyled } from '../../../../theme/buttons';
import { Button } from '@mui/material';
import { UpdateSections } from './update';

export const ViewSections = () => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const navigate = useNavigate();
  const [sectionLocal, setSectionLocal] = useState<Section>();
  const [openDialog, setOpenDialog] = useState(false);
  const [dataloaded, setDataLoaded] = useState(false);
  const { GenericGetResource, GenericDeleteResource } = GenericPromises();
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const { GetResourceByUrl } = usePermissions();

  const onDelete = () => {
    GenericDeleteResource(`/sections/${sectionLocal?.section_id}`)
      .then(() => {
        setOpenDialog(false);
        navigate("/sections", { state: { method: "delete" }, replace: true });
      })
      .catch((error) => {
        showSnackBar(error.message, 'error');
        setOpenDialog(false);
      })
  }

  useEffect(() => {
    if (location.state === null) return navigate("/sections", { state: {}, replace: true });
    GenericGetResource(`/sections/${location.state.row.section_id}`)
      .then(
        (response) => {
          setSectionLocal(response.data);

          GetResourceByUrl(`/sections`)
            .then((response1) => {
              setResourceScreen((prev) => response1);
              setDataLoaded(true);
            })
            .catch((error) => {
              showSnackBar(error.message, 'error');
            });
        }
      ).catch((error) => {
        showSnackBar(error.message, 'error');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!dataloaded && <Spinner />}
      {dataloaded &&
        <>
          <Header
            title={t("sections.title-view")}
            child={
              <div className='d-flex flex-row-reverse m-1'>
                {resourceScreen?.delete === true &&
                  <ButtonStyled variant="contained" className="my-1" onClick={() => setOpenDialog(true)}>{t("generic.buttons.delete")}</ButtonStyled>
                }
                <Button variant="outlined" className="my-1" onClick={() => { navigate("/sections", { replace: true }) }}>{t("generic.buttons.goback")}</Button>
              </div>
            }
          />
          <div>
            <UpdateSections sectionPayload={sectionLocal} isEdit={!resourceScreen?.update} />
          </div>

        </>
      }
      <GenericDialog
        title={t("generic.dialog.delete")}
        content={t("sections.dialog.delete")}
        open={openDialog}
        setOpen={setOpenDialog}
        onAcept={onDelete}
      />
      <SnackbarComponent />
    </>
  )
}
